const WORDS = ["Auto", "Hogar", "Gastos Médicos", "Vida", "Confianza", "Tradición", "Familia", "Tranquilidad"];

export const Marquee = () => (
  <div data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-y border-white/10 bg-[#0C5F8A] py-6">
    <div className="animate-marquee flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {WORDS.map((word) => (
            <span key={`${copy}-${word}`} className="flex items-center">
              <span className="font-editorial text-2xl text-white/95 sm:text-3xl">{word}</span>
              <span className="mx-8 text-xl text-[#F5B21B] sm:mx-10">✳</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
